import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import { addPrefixIfMissing } from 'Data/format.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import mutation from './mutation.graphql.js'
import { useEffect, useRef } from 'react'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'global',
    viewPath: props.viewPath,
  })
  let search_term = useDataValue({
    viewPath: props.viewPath,
    context: 'search',
    path: 'term',
  })
  let setFlowTo = useSetFlowTo(props.viewPath)
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)

  let cancel = useRef(false)
  useEffect(() => {
    return () => {
      cancel.current = true
    }
  }, []) // eslint-disable-line

  return async function onClick() {
    let mutationResponse = await executeMutation({
      number: addPrefixIfMissing(search_term),
    })

    if (mutationResponse.error) {
      return notify(notifyError(`There was a problem starting this thread.`))
    }

    submit({
      type: 'tabs/add',
      tab: {
        id: 'Comms',
        name: 'Comms',
        type: 'Comms',
        viewPath: '/App/Account/Content/Comms',
        sync: {
          threadId: mutationResponse.data.thread.id,
        },
      },
    })
    setFlowTo(normalizePath(props.viewPath, '../../../../../No'))
  }
}
